function formatDate(dateString, lang, type=0) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const date = new Date(dateString);
  const day = date
    .getDate()
    .toString()
    .padStart(2, '0');
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  if (type === 0) {
    if (lang === 'en') {
      return `${day} ${month} ${year}`;
    } else {
      return `${year}年${date.getMonth() + 1}月${day}日`;
    }
  } else {
    if (lang === 'en') {
      return `${day} / ${month}`;
    } else {
      return `${date.getMonth() + 1}月${day}日`;
    }
  }
}

function getLanguageList() {
  return [
    { value: 'en', label: 'EN', data: 'en' },
    { value: 'tc', label: '繁', data: 'zh-HK' },
    { value: 'sc', label: '简', data: 'zh-CN' }
  ];
}

export { formatDate, getLanguageList };